// Raporlar mega menüsünün tek kaynağı (single source of truth).
// Yeni bir rapor eklemek için ilgili kategorinin `items` dizisine tek satır ekleyin.
// `role` alanı fetchPermission ile uyumludur: tek rol veya "ROLE_A || ROLE_B" yazılabilir.

export type ReportMenuItem = {
  to: string;
  title: string;
  role: string;
};

export type ReportMenuCategory = {
  title: string;
  items: ReportMenuItem[];
};

export const reportsMenuCategories: ReportMenuCategory[] = [
  {
    title: 'Satış',
    items: [
      { to: '/reports/ai-query', title: '✨ AI Rapor Asistanı', role: 'ROLE_ADMIN' },
      { to: '/reports/sales-summary', title: 'Satış Özet Raporları', role: 'ROLE_REPORT_SALESS' },
      { to: '/reports/sales-dashboard', title: 'Satış Raporları (Detaylı)', role: 'ROLE_REPORT_SALES' },
      { to: '/reports/salesperson-performance', title: 'Satış Elemanı Performansı', role: 'ROLE_ADMIN' },
      { to: '/reports/salesman-quarterly-review', title: 'Çeyreklik Toplantı Raporu', role: 'ROLE_ADMIN' },
    ],
  },
  {
    title: 'Apple & Stok',
    items: [
      { to: '/reports/apple-sales-analysis', title: 'Apple Satış Analizi', role: 'ROLE_ADMIN' },
      { to: '/reports/apple-sector-report', title: 'Apple Sektör Raporu', role: 'ROLE_ADMIN' },
      { to: '/reports/apple-new-customers', title: 'FY Yeni Müşteriler (Apple)', role: 'ROLE_ADMIN' },
      { to: '/reports/apple-weekly-report', title: 'Apple Haftalık Raporu', role: 'ROLE_ADMIN' },
      { to: '/reports/purchase-sales-comparison', title: 'Stok Öneri Raporları', role: 'ROLE_REPORT_STOCK' },
      { to: '/reports/stock-movement-analysis', title: 'Durgun Stok Raporu', role: 'ROLE_REPORT_AGED_STOCK' },
    ],
  },
  {
    title: 'Müşteri',
    items: [
      { to: '/reports/admin-customers', title: 'Tüm Müşteriler', role: 'ROLE_ADMIN' },
      { to: '/reports/assigned-customers-report', title: 'Potansiyel Müşteriler', role: 'ROLE_ADMIN' },
      { to: '/reports/dep-customer-analysis', title: 'DEP Müşteri Analizi', role: 'ROLE_ADMIN' },
      { to: '/reports/contact-tracking-report', title: 'İletişim Bilgisi Takibi', role: 'ROLE_ADMIN' },
    ],
  },
  {
    title: 'Etkileşim & Pazarlama',
    items: [
      { to: '/reports/interaction-report', title: 'Etkileşim Raporu', role: 'ROLE_ADMIN' },
      { to: '/reports/monthly-interaction', title: 'Ziyaret / İlk Fatura Raporu', role: 'ROLE_ADMIN' },
      { to: '/reports/quote-reports', title: 'Teklif Raporları', role: 'ROLE_ADMIN' },
      { to: '/admin/mailing-reports', title: 'Mailing Raporları', role: 'ROLE_ADMIN' },
    ],
  },
];
